import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from '../assets/pictures/ps-logo.webp';

import French from '../assets/pictures/france.webp';
import England from '../assets/pictures/united-kingdom.webp';

import '../utils/general.css';
import '../utils/navbar.css';

import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

import { useLanguage } from './languageContext'; // Importez le hook useLanguage
export default function NavBar() {
  const { language, changeLanguage } = useLanguage();

  const translations = language === 'en' ? enTranslations : frTranslations;

  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);

  useEffect(() => {
    if (!expanded) return;

    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [expanded]);

  return (
    <Navbar expand="lg" bg="dark" data-bs-theme="dark" fixed="top" expanded={expanded} onToggle={setExpanded} ref={navRef}>
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          <img
            alt=""
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Pierre Saumet
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/experiences" className='nav-font' onClick={() => setExpanded(false)}>{translations.navbar.experiences}</Nav.Link>
            <Nav.Link as={Link} to="/education" className='nav-font' onClick={() => setExpanded(false)}>{translations.navbar.education}</Nav.Link>
            <Nav.Link as={Link} to="/profil" className='nav-font' onClick={() => setExpanded(false)}>{translations.navbar.profil}</Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <NavDropdown title={translations.navbar.language} id="collapsible-nav-dropdown" className='nav-font ml-auto'>
              <NavDropdown.Item className='nav-font' onClick={() => changeLanguage('fr')}>
                <img
                  alt=""
                  src={French}
                  width="24"
                  height="24"
                />   {translations.navbar.french}
              </NavDropdown.Item>
              <NavDropdown.Item className='nav-font'onClick={() => changeLanguage('en')}>
                <img
                  alt=""
                  src={England}
                  width="24"
                  height="24"
                />   {translations.navbar.english}
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

